import { render, staticRenderFns } from "./SignCard.vue?vue&type=template&id=71c92b8d&scoped=true&"
import script from "./SignCard.vue?vue&type=script&lang=ts&"
export * from "./SignCard.vue?vue&type=script&lang=ts&"
import style0 from "./SignCard.vue?vue&type=style&index=0&id=71c92b8d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71c92b8d",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VCard,VCardText,VIcon})
